import ActiveListing from './ActiveListing'

export default ActiveListing
